<script lang="ts">
  import DownloadSimple from "~icons/ph/download-simple-bold";

  let {
    href,
    label,
    class: className,
  }: {
    href: string;
    label: string;
    class?: string;
  } = $props();
</script>

<a href={href} class="text-blue-600 underline font-semibold flex gap-2 items-center {className}" target="_blank">
  <DownloadSimple class="w-4 h-4" />{label}
</a>
